<template>
  <div class="grupo-page">
    <div class="container">
      <div class="grupo-content">

        <!-- El Grupo Section -->
        <section id="el-grupo" class="grupo-section">
          <h2 class="section-heading">El Grupo</h2>
          <p>Grupo Babilonia nace en la ciudad de Montevideo, Uruguay en el año 1995, con el estreno de la obra teatral "Querida espero que te mueras" de Hugo Manuel Mieres; espectáculo unipersonal protagonizado por Eduardo Migliónico, dirigido por Alejandra Weigle y Hugo Manuel Mieres.</p>

          <p>Durante varios años, además de haber realizado obras en salas de teatro, Grupo Babilonia adquiere una vasta experiencia en espacios no convencionales, con un público más cercano y activo.</p>

          <p>Nuestro interés como grupo de teatro siempre ha sido el de preservar nuestra riqueza cultural histórica. Entendemos la defensa de nuestro patrimonio cultural como una apuesta al futuro, a la convicción de que estas características peculiares nos otorgan un espacio para el diálogo y comprensión intercultural.</p>
        </section>

        <!-- Quien Somos Section -->
        <section id="quien-somos" class="grupo-section">
          <h2 class="section-heading">Quién Somos</h2>
          <p>Eduardo Migliónico y Alejandra Weigle, fundadores del grupo, integraron el elenco de teatro El Galpón de Montevideo desde 1988 hasta 1992.</p>

          <p>En el año 2012 comienzan los trabajos desde El Pinar, Ciudad de la Costa, donde realizan numerosos talleres de teatro y performances.</p>

          <p>Al día de hoy, Grupo Babilonia participa activamente como miembro de la Asociación de Teatros del Interior (ATI).</p>
        </section>

        <!-- Historia Section -->
        <section id="historia" class="grupo-section">
          <h2 class="section-heading">Historia</h2>

          <h3 class="subsection-title">Teatro en la Costa</h3>
          <p>La Ciudad de la Costa, siendo segunda en cantidad de habitantes del país, siempre ha sido un foco sumamente receptivo a propuestas artísticas. Es por este motivo que Grupo Babilonia siempre ha apostado a romper el hielo con propuestas culturales, para que otros grupos se sumen a esta iniciativa.</p>

          <p>Esto conllevó al inicio de un proceso de profunda investigación que culminaría con el estreno de <strong>"Los Descreídos"</strong> en enero del 2015, un espectáculo inspirado en el folklore mágico del Uruguay. Esta obra pretende rescatar la riqueza literaria de los mitos, sus enseñanzas, su temperamento; ya que preservar aquello que nos diferencia como cultura, enriquece el patrimonio de toda la humanidad.</p>

          <p>Desde el estreno de "Los Descreídos", Grupo Babilonia ha trabajado en Ciudad de la Costa de forma constante e ininterrumpida. Ha producido y realizado espectáculos artísticos que revalorizan la cultura nacional; ha trabajado en conjunto con organismos departamentales en proyectos de integración social a través del arte; ha realizado talleres intensivos y de aproximación al teatro, dirigidos a los pobladores de la zona.</p>

          <h3 class="subsection-title">Un Nuevo Proyecto</h3>
          <p>Inspirado en el circo criollo, expresión única y original del Río de la Plata, <strong>"El Circo Olvidado"</strong> pretende recrear, en clave actual, la forma artística de aquel circo de antaño que supo combinar y sintetizarse con el teatro, dando lugar a un circo con argumento.</p>

          <p>El espectáculo se concibe para presentarse en espacios abiertos, entre los médanos de las costas uruguayas, parques y plazas públicas. No obstante, también se ha llevado a salas más tradicionales como Sala Verdi y el Florencio Sánchez de Montevideo, comprobando la adaptabilidad del espectáculo en el recibimiento y respuesta de la gente.</p>

          <p class="cta-text">
            <router-link to="/obras" class="obras-link">Conocé más sobre nuestras obras →</router-link>
          </p>
        </section>

        <!-- Premios Section -->
        <section id="premios" class="grupo-section">
          <h2 class="section-heading">Premios</h2>
          <p>"Los Descreídos" fue ganadora de 3 premios Florencio Sánchez (máximo galardón del teatro uruguayo) en 2017:</p>

          <div class="premios-list">
            <div class="premio-item">
              <span class="premio-icon">🏆</span>
              <div class="premio-info">
                <span class="premio-name">Mejor Espectáculo</span>
                <span class="premio-year">Premios Florencio 2017</span>
              </div>
            </div>
            <div class="premio-item">
              <span class="premio-icon">🏆</span>
              <div class="premio-info">
                <span class="premio-name">Mejor Dirección</span>
                <span class="premio-year">Premios Florencio 2017</span>
              </div>
            </div>
            <div class="premio-item">
              <span class="premio-icon">🏆</span>
              <div class="premio-info">
                <span class="premio-name">Mejor Actor</span>
                <span class="premio-year">Premios Florencio 2017</span>
              </div>
            </div>
          </div>

          <p style="margin-top: 30px;">"Circo Olvidado" obtuvo 2 premios Florencio Sánchez en 2019:</p>

          <div class="premios-list">
            <div class="premio-item">
              <span class="premio-icon">🏆</span>
              <div class="premio-info">
                <span class="premio-name">Mejor Espectáculo</span>
                <span class="premio-year">Premios Florencio 2019</span>
              </div>
            </div>
            <div class="premio-item">
              <span class="premio-icon">🏆</span>
              <div class="premio-info">
                <span class="premio-name">Mejor Dirección</span>
                <span class="premio-year">Premios Florencio 2019</span>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElGrupoPage',
  mounted() {
    this.$nextTick(() => {
      const hash = this.$route.hash;
      if (hash) {
        // Scroll to section if hash exists
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo(0, 0);
      }
    });
  },
  watch: {
    '$route.hash'(newHash) {
      if (newHash) {
        const el = document.querySelector(newHash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.scrollTo(0, 0);
      }
    }
  }
}
</script>

<style scoped>
.grupo-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

.grupo-content {
  max-width: 800px;
  margin: 0 auto;
  color: white;
}

.grupo-section {
  margin-bottom: 60px;
  padding-top: 20px;
}

.grupo-section:last-child {
  margin-bottom: 0;
}

.section-heading {
  font-size: 32px;
  font-weight: bold;
  color: #c9a227;
  margin: 0 0 25px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #333;
  padding-bottom: 15px;
}

.subsection-title {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  margin: 35px 0 15px 0;
  font-style: italic;
}

.grupo-content p {
  font-size: 18px;
  line-height: 1.8;
  color: #ddd;
  margin: 0 0 20px 0;
  text-align: justify;
}

.grupo-content p:last-child {
  margin-bottom: 0;
}

.grupo-content p strong {
  color: #c9a227;
}

/* CTA Link to Obras */
.cta-text {
  margin-top: 30px;
}

.obras-link {
  display: inline-block;
  color: #c9a227;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  border-bottom: 2px solid #c9a227;
  padding-bottom: 3px;
  transition: all 0.3s ease;
}

.obras-link:hover {
  color: #fff;
  border-color: #fff;
}

/* Premios List */
.premios-list {
  margin-top: 30px;
}

.premio-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 25px;
  background: rgba(201, 162, 39, 0.1);
  border-left: 4px solid #c9a227;
  margin-bottom: 15px;
  border-radius: 0 8px 8px 0;
}

.premio-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.premio-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.premio-name {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}

.premio-year {
  font-size: 14px;
  color: #aaa;
}

/* Mobile */
@media (max-width: 767px) {
  .grupo-page {
    padding: 40px 20px 60px;
  }

  .grupo-content p {
    font-size: 16px;
    line-height: 1.7;
    text-align: left;
  }

  .section-heading {
    font-size: 24px;
  }

  .subsection-title {
    font-size: 18px;
  }

  .grupo-section {
    margin-bottom: 40px;
  }

  .premio-item {
    flex-direction: row;
    gap: 15px;
    padding: 15px 20px;
  }

  .premio-icon {
    font-size: 28px;
  }

  .premio-name {
    font-size: 16px;
  }

  .premio-year {
    font-size: 13px;
  }
}
</style>